import { createTheme } from "@mui/material/styles"

// Create a dark theme for the DarkEdge website with colors matching the logo
const theme = createTheme({
  palette: {
    mode: "dark",
    primary: {
      main: "#00e5ff", // Neon cyan color from the logo
    },
    secondary: {
      main: "#0288d1", // Darker blue for secondary elements
    },
    background: {
      default: "#000000", // Pure black background
      paper: "#121212", // Slightly lighter black for cards/surfaces
    },
    text: {
      primary: "#ffffff",
      secondary: "rgba(255, 255, 255, 0.7)",
    },
    error: {
      main: "#f44336",
    },
    warning: {
      main: "#ff9800",
    },
    success: {
      main: "#4caf50",
    },
  },
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    button: {
      textTransform: "none",
    },
  },
  components: {
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: "#121212", // Dark app bar
          borderBottom: "1px solid rgba(0, 229, 255, 0.12)", // Subtle cyan border
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 4,
        },
        containedPrimary: {
          background: "linear-gradient(45deg, #00e5ff 30%, #2979ff 90%)", // Gradient effect similar to the glowing logo
          boxShadow: "0 0 10px rgba(0, 229, 255, 0.5)", // Glow effect
        },
      },
    },
    MuiLink: {
      styleOverrides: {
        root: {
          "&:hover": {
            color: "#00e5ff", // Cyan hover color for links
          },
        },
      },
    },
  },
})

export default theme
